import React, { useState, useEffect } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";

const DatePickerTarjeta = ({
  fullWidth,
  onChange,
  onKeyDown,
  value,
  minDate,
  maxDate,
  className,
  label,
  id,
  error,
  onBlur,
  reference,
}) => {
  const [selectedDate, setSelectedDate] = useState(value);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (onChange) onChange(date);
  };

  const handleBlur = () => {
    if (onBlur) onBlur();
  };

  useEffect(() => {
    setSelectedDate(value);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        views={["year", "month"]}
        openTo="month"
        inputFormat="MM/yy"
        minDate={minDate}
        maxDate={maxDate}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth={fullWidth}
            margin="normal"
            id={id}
            error={!!error}
            onBlur={handleBlur}
            onKeyDown={onKeyDown}
            className={className}
            inputRef={reference}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePickerTarjeta;
